import { PageConfig } from "../../router";
import UserForm from "../../components/dashboard/user/UserForm";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Luna - User Page",
  description: "Luna - User Page",
};

export default function AddUserPage() {
  return (
    <>
      <MetaComponent meta={metadata} />
      <div className="dashboard__main h-100">
        <div className="dashboard__content bg-light-2 h-100 w-100">
          <div className="d-flex flex-column h-100 mb-20 overflow-y-scroll">
            <UserForm />
          </div>
        </div>
      </div>
    </>
  );
}

export const AddUserPageConfig: PageConfig = {
  path: "/users/add",
  component: AddUserPage,
  roles: ["admin", "root"],
};
